// extracted by mini-css-extract-plugin
module.exports = {"testSubjectRating":"TestSubjectRating_testSubjectRating__3cGzP","title":"TestSubjectRating_title__3lmCV","buttons":"TestSubjectRating_buttons__w7h1i"};